import app from "app.controller"
import Filter from "components/Filter/Filter"
import ProductCol from "components/Product/ProductCard"
import SearchBar from "components/Search/SearchBar"
import SearchBarWithOptions from "components/Search/SearchBarWithOptions"
import Spinner from "components/Spinner/Spinner"
import PropTypes from "prop-types"
import Responsive from "react-responsive"
import queryString from "qs"
import React, { Component } from "react"
import { browserHistory } from "react-router-dom"
import { Link, NavLink, withRouter }                                                                 from "react-router-dom"
import { Accordion, Button, Card, Checkbox, Container, Dropdown, Form, Icon, Menu, Pagination, Radio, Sticky } from "semantic-ui-react"
import cmsStore from "stores/cmsStore"
import historyStore from "stores/historyStore"
import productStore from "stores/productStore"
import settingStore from "stores/settingStore"
import MenuBySlug from "components/Menu/MenuBySlug"
import shop                                                                                          from "shop/shop"

export default class SearchPage extends Component {
  constructor( props ) {
    super(props)
    let search = queryString.parse( props.location.search, { ignoreQueryPrefix: true } )
    this.state = {
      loading : true,
      search  : search.q || "",
      products: [],
      filter  : {
        total      : 64,
        pageSize   : 64,
        currentPage: 1,
      }, query: {
        q    : search.q || "",
        page : search.page || 1,
        count: search.count || 10,
      }

    }

    this.load()
    app.search.change.add( this.handleSearch )
  }

  handleSearch = ( e = {} ) => {
    let q = ""
    if ( e.target && e.target.value ) q = e.target.value
    if ( e.q ) q = e.q

    let query = this.state.query

    if ( this.state.search !== e ) {
      query.page = 1
    }

    this.setState( { search: q, query }, () => {
      if ( q.length >= 3 ) {
        this.load()
      } else {
        this.setState( {
          products: [],
          size    : 0
        } )
        return
      }
    } )
  }

  onChangeFilter = ( filter ) => {
    this.updateQuery( filter )
  }

  addQuery( query ) {
    this.props.history.replace( `${this.props.location.pathname}?${queryString.stringify( query )}` )
    return query
  }

  updateQuery( { page, dir, sort, pageSize } ) {
    let query = this.state.query
    query.page = page || query.page
    query.dir = dir || query.dir
    query.count = pageSize || query.count
    query.sort = sort || query.sort
    query.q = this.state.search

    this.addQuery( query )
    this.setState( { query }, () => {
      this.load()
    } )
  }

  load() {
    let { query } = this.state
    historyStore.set( {
      link   : `/search?q=${this.state.search}`,
      content: `${translate( "zurück zur Suche" )} "${this.state.search}"`,
    } )

    let additionalFilters = []

    const mode = settingStore.get( "orderMode" )
    if ( mode === "MODE_PREORDER" ) {

      let filterPreorder = {
        op   : "equals",
        field: "vororder",
        extra: true,
        value: true
      }

      additionalFilters.push( filterPreorder )
    }

    if ( mode === "MODE_AVAILABLE" ) {

      let filterSofortorder = {
        op   : "equals",
        field: "sofortorder",
        extra: true,
        value: true
      }
      additionalFilters.push( filterSofortorder )
    }

    // if ( cmsStore.config.plugin.hideVariants ) {
    //   // FILTER ALL VARIANTS (ONLY MAIN-ARTCILES)
    //   let noVariants = {
    //     op:    "equals",
    //     field: "type",
    //     value: "1"
    //   }
    //   const singleItems = { "field": "mainArticle", "op": "equals", "value": "" }
    //   let combinedFilter = [{ "or": [singleItems, noVariants] }]
    //   additionalFilters = additionalFilters.concat( combinedFilter ) // this shows only mainarticles (i.e. no-variants))
    // }
    //mainart : 1 IF ONLY FOR MAINARTICLE FILTER
    
    this.setState( { loading: true } )
    productStore.search( this.state.search, {
      filter  : additionalFilters,
      count   : 64,
      page    : query.page,
      sort    : query.sort,
      dir    : query.dir,
      artnr   : 1
    }, { useArtNr: false } )
      .then( response => {
        let { query } = this.state
        query.q = this.state.search
        let { products = [] } = response

        this.setState( {
          size   : response.size,
          products,
          loading: false
        } )
        this.addQuery( query )
      } )
      .catch( err => {
        console.error( err )
        this.setState( { loading: false } )
      } )
  }

  componentWillUnmount() {
    app.search.change.remove( this.handleSearch )
  }

  render() {


    const query = queryString.parse( this.props.location.search.slice( 1 ) )

    console.log( { query, state: this.state.query } )

    let filter = {
      currentPage: Number( this.state.query.page ),
      total      : Number( this.state.size ),
      brand      : String( this.state.query.brand ),
      pageSize   : 64,
      dir        : this.state.query.dir || "desc",
      sort       : String( this.state.query.sort || "sort" )
    }

    const { loading } = this.state
    const { lastSearchURL } = productStore

    let filterSection = <section className="cf pb3">
      <Filter hideDirections hidePageSize={true} onChange={this.onChangeFilter} {...filter} />
    </section>

    const { products } = this.state

    return (
      <div className="SearchPage ">
              <div className="backgroundImageBannerShop" ></div>
      <div className="FilterPageHeader">
      <Container className="" style={{paddingTop: '2vh'}}>
          <MenuBySlug
                            key={"mini-header"}
                            slug={"header"}
                            secondary
                            borderless>
                            {shop.session && <Menu.Item><Link to="/orderlist"><p className="f4 fw5 black-60">MERKLISTE</p></Link> </Menu.Item>}
                            {shop.session && <Menu.Item><Link to="/account"><p className="f4 fw5 black-60">MEIN KONTO</p></Link> </Menu.Item>}
                            {shop.session && <Menu.Item><Link to="/logout"><p className="f4 fw5 black-60">ABMELDEN</p></Link></Menu.Item>}
                            {!shop.session && <Menu.Item className={"primary"} as={Link} to={"/login/"}><p className="f4 fw5 black-60">{translate( "Anmelden" )}</p></Menu.Item>}
                            {/*!shop.session && <Menu.Item as={Link} to={"/customer_registration/"}><p className="f4 fw5 black-60">{translate( "Registrieren" )}</p></Menu.Item>*/}
          
                            {/*shop.categories.map(category => {
                    return <Menu.Item as={Link} className="dib f6 pr2" key={category.map_id} to={`/collection/${category.map_id}/`}><div><img width="40" src={category.img_src}/></div>
                    <div>{category.desc.des}</div></Menu.Item>
                            })*/}
                            <Responsive maxWidth={768}><Menu.Item onClick={app.sidebarLeft.toggle.dispatch}><Icon
                              name="bars"/></Menu.Item>
                            </Responsive>
                          </MenuBySlug>
      </Container>
      </div>
        
        <div className="pt4-ns pt2">
          
          <Container>
            <SearchBarWithOptions loading={loading} results={products}/>
            {/*<div className="mw6 center">*/}
            {/*<SearchBar/>*/}
            {/*</div>*/}
            {this.state.size > 0 ? filterSection : null}
            {loading && <Spinner/>}
            <section className="mb5">
              {!loading && <div>{(!loading && products && products.length > 0) ? null : <div className="tc pa4">{translate( "Keine Produkte gefunden." )}</div>}</div>}
              {!loading && <Card.Group itemsPerRow={4} doubling>
                {this.state.products.map( product => <ProductCol
                  sm="1/2"
                  key={product.map_id}
                  product={product}/> )
                }
              </Card.Group>
              }
            </section>
            {this.state.size > 0 ? filterSection : null}
          </Container>
        </div>
      </div>
    )
  }
}

SearchPage.propTypes = {
  params: PropTypes.object, filter: PropTypes.object, location: PropTypes.object
}



// WEBPACK FOOTER //
// ./src/theme/lucht-test/pages/SearchPage.js